export default "__VITE_ASSET__dV2jwoka__"